import { Command } from './Command';
import { InsuranceCommandParams } from './InsuranceCommandParams';

export type SearchMedicamentsParams = InsuranceCommandParams & {
	medicamentCode: string[];
};

export const SearchMedicaments = (params: SearchMedicamentsParams): Command => {
	return {
		operation: 'NajdiLieky_v6',
		params,
	};
};
